import { jsx } from 'panel';
import { EmptyReportHeroEl } from 'common/widgets/empty-report-hero';
import { WorkspaceStatus } from 'common/widgets/workspace-global-only-banner/types';
export function template() {
  const {
    globalProjectWorkspace,
    workspaceStatus
  } = this.state;
  return jsx("div", {
    sel: '.workspace-global-only-banner'
  }, workspaceStatus === WorkspaceStatus.NO_WORKSPACE_ACCESS ? jsx(EmptyReportHeroEl, {
    attrs: {
      'header-text': "Only Available in the Global Data View",
      'body-text': globalProjectWorkspace ? "Mixpanel ".concat(this.helpers.getAppName(), " ").concat(this.helpers.getIsOrAre(), " only available from ").concat(globalProjectWorkspace.name, " (Global Data View)") : "Mixpanel ".concat(this.helpers.getAppName(), " ").concat(this.helpers.getIsOrAre(), " only available from the Global Data View")
    }
  }, !globalProjectWorkspace ? jsx("div", {
    sel: '.more'
  }, "You are not a member of the Global Data View and it is private.", jsx("div", {
    sel: '.more'
  }, "Contact your project Admin or Owner for access."), jsx("div", {
    sel: '.cta-links'
  }, jsx("a", {
    sel: '.btn-link',
    attrs: {
      href: this.helpers.getAppUrl({
        appPath: "insights",
        projectId: this.helpers.getProjectId(),
        workspaceId: this.attr("workspace-id")
      })
    }
  }, "Go to Insights in this Data View"))) : jsx(null, null, jsx("div", {
    sel: '.more'
  }, "You are not a member of the Global Data View but it can be joined using the Data View Library."), jsx("div", {
    sel: '.cta-links'
  }, jsx("a", {
    attrs: {
      href: this.helpers.getAppUrl({
        appPath: "insights",
        projectId: this.helpers.getProjectId(),
        workspaceId: this.attr("workspace-id")
      })
    }
  }, "Go to Insights in this Data View"), jsx("a", {
    sel: '.btn-link',
    attrs: {
      href: this.helpers.getAppUrl({
        appPath: "views",
        projectId: this.helpers.getProjectId()
      })
    }
  }, "Go to Data View Library")))) : jsx(EmptyReportHeroEl, {
    attrs: {
      'header-text': "Only Available in the Global Data View",
      'body-text': "Mixpanel ".concat(this.helpers.getAppName(), " ").concat(this.helpers.getIsOrAre(), " only available from ").concat(globalProjectWorkspace.name, " (Global Data View)")
    }
  }, jsx("div", {
    sel: '.cta-links'
  }, jsx("a", {
    attrs: {
      href: this.helpers.getAppUrl({
        appPath: "insights",
        projectId: this.helpers.getProjectId(),
        workspaceId: this.attr("workspace-id")
      })
    }
  }, "Go to Insights in this Data View"), jsx("a", {
    sel: '.btn-link',
    attrs: {
      href: this.helpers.getAppUrl({
        appPath: this.helpers.getAppPath(),
        projectId: this.helpers.getProjectId(),
        workspaceId: globalProjectWorkspace.id
      })
    }
  }, "View in Global Data View"))));
}